import { render, staticRenderFns } from "./propertyDeductionReport.vue?vue&type=template&id=5775706a&scoped=true"
import script from "./propertyDeductionReport.vue?vue&type=script&lang=js"
export * from "./propertyDeductionReport.vue?vue&type=script&lang=js"
import style0 from "./propertyDeductionReport.vue?vue&type=style&index=0&id=5775706a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5775706a",
  null
  
)

export default component.exports